import React from "react";
import { Link } from "react-router-dom";
import { Network, UserSearch } from "lucide-react";
import {
  TABLE_VIEW,
  TREE_VIEW,
  workflowsViewPath,
} from "./workflowsUrls";

// The page answers two unrelated questions off the same config, and which one
// you want decides the whole layout, so it is worth asking up front.
const CHOICES = [
  {
    view: TREE_VIEW,
    icon: Network,
    title: "Understand Workflows",
    blurb:
      "Walk one specialty's routes as a flowchart to see how a visit is matched, and which template it lands on.",
    hint: "Start with a specialty",
  },
  {
    view: TABLE_VIEW,
    icon: UserSearch,
    title: "Look Up Workflows by Doctor",
    blurb:
      "List every route that applies to one doctor, in the order the backend evaluates them, with the templates each one resolves to.",
    hint: "Start with a doctor",
  },
];

/** Landing screen for /workflows/visualization, before a view is committed to. */
function ViewChooser() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center rounded-lg border border-gray-200 bg-gray-50 px-6 py-16 text-center">
      <p className="text-base font-semibold text-gray-700">
        What are you trying to find out?
      </p>
      <p className="mt-1 max-w-lg text-sm text-gray-500">
        Pick whichever question you're answering — you can switch without losing
        your place.
      </p>

      <div className="mt-6 grid w-full max-w-3xl gap-4 sm:grid-cols-2">
        {CHOICES.map(({ view, icon: Icon, title, blurb, hint }) => (
          <Link
            key={view}
            to={workflowsViewPath(view)}
            className="group flex cursor-pointer flex-col items-start rounded-lg border border-gray-300 bg-white p-5 text-left transition-colors hover:border-ktx-purple"
          >
            <Icon className="h-6 w-6 text-gray-400 transition-colors group-hover:text-ktx-purple" />
            <span className="mt-3 text-sm font-semibold text-gray-900 group-hover:text-ktx-purple">
              {title}
            </span>
            <span className="mt-1.5 text-sm leading-relaxed text-gray-500">
              {blurb}
            </span>
            <span className="mt-3 text-xs font-medium uppercase tracking-wide text-gray-400">
              {hint}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default ViewChooser;
